#!/usr/bin/env node

import { LLMail } from '../LLMail.js';
import { realFileSystemAdapter } from '../utils/file-system-adapter.js';
import { loadLlmailConfig } from '../utils/config.js';
import { logger } from '../utils/logger.js';
import yargs from 'yargs';
import { hideBin } from 'yargs/helpers';

async function main() {
  const argv = yargs(hideBin(process.argv))
    .usage('Usage: $0 <id> [options]')
    .option('state', {
      alias: 's',
      type: 'string',
      description: 'State to mark the item as done (inactive state)'
    })
    .option('frontmatter', {
      alias: 'f',
      type: 'string',
      description: 'JSON string representing additional frontmatter updates'
    })
    .demandCommand(1, 'You must provide the id of the item to mark as done')
    .help()
    .parseSync();

  // Get the positional argument 'id'
  const id = argv._[0] as string;

  // Build options object for llmail.done()
  const options: any = {};
  if (argv.state) {
    options.state = argv.state;
  }
  if (argv.frontmatter) {
    try {
      options.frontmatter = JSON.parse(argv.frontmatter);
    } catch (err) {
      console.error('Error parsing frontmatter JSON:', err);
      process.exit(1);
    }
  }

  const fsAdapter = realFileSystemAdapter;
  const rootDir = process.cwd();
  const configPath = argv.config as string | undefined;

  try {
    const config = await loadLlmailConfig(fsAdapter, rootDir, configPath);
    const llmail = new LLMail({ fs: fsAdapter, config });
    await llmail.init();

    await llmail.done(id, options);
    logger.success(`Item ${id} marked as done successfully.`);
  } catch (error) {
    console.error('Error marking item as done:', error);
    process.exit(1);
  }
}

main(); 